// English customer copy follows the canonical Web v3 October 2 simplification.
// Server-owned policy/outcome text, state transitions and permitted actions remain unchanged.
// Spanish: the Founder's full review of 2026-10-06, applied by scripts/apply-spanish-review.js.

export const en = {
  // A CONSENT TEXT Backend freezes byte for byte: straight ' (the Terms-sentence
  // rule, not the UI typography). Pinned by copyRc10Review.test.ts.
  "guest.review.policyConsent": "By continuing, you agree to the professional's cancellation policy shown above.",
  "guest.review.policyUnavailable": "We couldn’t load the cancellation policy.",
  "guest.review.heading": "Review your booking",
  "guest.review.contact": "Your details",
  "guest.review.appointment": "Appointment",
  "guest.review.changeTime": "Change time",
  "guest.review.changeService": "Change service",
  "guest.review.editDetails": "Edit details",
  "guest.review.continue": "Continue",
  "guest.details.emailHint": "Booking updates go here.",
  "guest.code.heading": "Confirm your email",
  "guest.code.sub": "Check {email} for your code.",
  "guest.code.label": "Six-digit code",
  "guest.code.confirm": "Verify and submit",
  // CONSENT TEXT, frozen by Backend (straight quotes; the Terms-sentence
  // rule). The bracketed words open the policy shown on Review, in the page.
  // Pinned by copyRc10Review.test.ts.
  "guest.code.policyConsent": "By selecting \"Verify and submit,\" you agree to the professional's [cancellation policy] shown on the review screen.",
  "guest.code.confirming": "Submitting…",
  "guest.code.resend": "Resend code",
  "guest.code.resendIn": "Resend code in {wait}",
  "guest.code.resendAt": "Resend code at {time}",
  "guest.code.sending": "Sending code…",
  "guest.code.changeEmail": "Change email",
  "guest.code.incorrect": "Use the code in your latest email.",
  "guest.code.incorrectLeftOne": "Incorrect code. 1 attempt left.",
  "guest.code.incorrectLeftMany": "Incorrect code. {count} attempts left.",
  "guest.code.expired": "Code expired.",
  "guest.code.exhausted": "Too many attempts.",
  "guest.code.verifyLimited": "Try again at {time}.",
  "guest.code.verifyLost": "We couldn’t confirm your code. Try again.",
  "guest.code.resendLimited": "You can resend at {time}.",
  "guest.code.resendLost": "Check your email for your code.",
  "guest.code.challengeGone": "This code can’t be used anymore.",
  "guest.code.unverifiedAtSubmit": "Please confirm your email again before booking.",
  "guest.code.sendNew": "Send a new code",
  "guest.code.sessionUnavailable": "We couldn’t reach your booking session. Try again.",
  "guest.code.sessionUnavailableReady": "We couldn’t finish booking. Try again.",
  "guest.uncertain.sessionUnavailable": "The result is still unavailable. Check before booking again.",
  "guest.offline": "You’re offline. Reconnect to continue.",
  "guest.hold.finishByToday": "Finish booking by {time} today",
  "guest.hold.finishByOn": "Finish booking by {time} on {date}",
  "guest.change.heading": "Change email",
  "guest.change.label": "Email",
  "guest.change.send": "Send code",
  "guest.change.back": "Back",
  "guest.holdEnded.heading": "Choose your time again",
  "guest.holdEnded.sub": "",
  "guest.holdEnded.recheck": "Check this time again",
  "guest.holdEnded.another": "Choose another time",
  "guest.unavailable.heading": "We couldn’t send the code",
  // Restored from the approved pre-v3 copy (f57d4f4) for rc.1: the v3 copy
  // pass left these screens with a heading and no next step.
  "guest.unavailable.body": "No booking was made. Please contact {business} or try again later.",
  "guest.requestProblem.heading": "We couldn’t send the code",
  "guest.requestProblem.body": "No booking was made.",
  // "Get help" with context (rc.1, pending the Founder's approval of the
  // wording). Only public, non-personal facts: never a name, email, phone,
  // code, token or /a/ link. See lib/support.ts.
  "guest.help.mail.subject": "Lura booking help",
  "guest.help.mail.intro": "Tell us what you were trying to do. Please don’t include codes or links from your emails.",
  "guest.help.mail.happened": "What happened: {heading}",
  "guest.help.mail.business": "Business: {business}",
  "guest.help.mail.page": "Page: {page}",
  "guest.help.mail.time": "Time: {time} ({zone})",
  "guest.help.mail.build": "Build: {build}",
  "guest.help.mail.reference": "Reference: {reference}",
  "guest.requestWait.heading": "A new code can be sent soon",
  "guest.requestWait.body": "You can resend at {time}.",
  "guest.requestLimited.heading": "Too many code requests",
  "guest.requestLimited.body": "You can resend at {time}.",
  "guest.identityLost.heading": "Start your booking again",
  "guest.identityLost.body": "Return to your booking.",
  "guest.identityLost.action": "Start again",
  "guest.uncertainNoCheck.body": "Contact support before booking again.",
  "guest.alreadyBooked.heading": "This booking may already exist",
  "guest.alreadyBooked.body": "Contact support before booking again.",
  "guest.cannotStart.heading": "We couldn’t start your booking",
  "guest.cannotStart.body": "We couldn’t finish booking.",
  "guest.help": "Get help",
  "guest.manage.confirmed": "Manage booking",
  "guest.manage.requested": "Manage request",
  "guest.outcome.requestedWhen": "Requested: {when}",
  "guest.outcome.with": "With",
} as const;
